// extracted by mini-css-extract-plugin
export default {"mainContainer":"nameAvatar_mainContainer__0o5jA","dropDownContainer":"nameAvatar_dropDownContainer__AphMr","itemContainer":"nameAvatar_itemContainer__zWpab"};